
import Vue from "vue";
import { AccountantService } from "@/services/accountant-service";
import AppErrorMessage from "@/components/common/ErrorMessageBox.vue";
import { HttpError } from "@/utils/services/http-error";

export default Vue.extend({
	data() {
		return {
			email: "",
			error: "",
			sending: false
		};
	},
	computed: {
		canSend():boolean {
			return this.email.includes("@") && !this.sending;
		}
	},
	methods: {
		close() {
			this.$emit("close");
		},
		async send() {
			if (!this.canSend) return;
			this.error = "";
			this.sending = true;
			try {
				await AccountantService.sendInvite(this.email.trim());
				this.$wf.notify(this.$ct("invite-sent").toString(), "success", 3000, "check");
				this.$emit("sent");
				this.close();
			} catch (err) {
				let error = err as HttpError;
				error.dontShow = true;
				this.error = error.getText();
			} finally {
				this.sending = false;
			}
		}
	},
	components: {
		AppErrorMessage
	},
	i18nEx: {
		componentPrefix: "components.accountant-InviteClientModal"
	}
});
